import type { ReactNode } from 'react';

export const symbol_reminder: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-620h60v-60q0-25.5-17.5-42.75T260-740q-25 0-42.5 17.5T200-680q0 25 17.25 42.5T260-620Zm180 0q25.5 0 42.75-17.5T500-680q0-25-17.5-42.5T440-740q-25 0-42.5 17.25T380-680v60h60Zm48 290ZM445-80q-29 0-56-12t-45-35L143-383q-7-9-7-20t8-19l4-4q14-15 34.5-18.5T221-438l99 53v-175h-60q-50 0-85-35t-35-85q0-50 35-85t85-35q16 0 31 4t29 12v-66q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v66q14.24-8 28.98-12 14.75-4 31.02-4 50 0 85 35t35 85q0 50-35 85t-85 35h-60v225q0 17-14.5 25.5t-29.5.5l-100-53 156 198q10 12 23.76 18 13.76 6 29.24 6h205q38 0 64-26t26-64v-170q0-25.5-17.25-42.75T680-460H490q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h190q50 0 85 35t35 85v170q0 63-43.5 106.5T650-80H445Z"
		/>
	</svg>
);
